import React from "react";
import style from "./success.module.scss";
import Modal from '../../Modal/Modal';
import Button from "../../Button/button"

const Success = (props) => {

    return (
        <div>
            <Modal
                tag="profileSuccess"
                value={props.successValue ? true : false}
                title="تکمیل اطلاعات پروفایل"
                parentClose={() => props.CloseModal()}>
                <div className={style.greenIcon}>f</div>
                <p className={style.text}>.کاربر عزیز، تغییرات با موفقیت اعمال شد</p>
                <Button
                    disabled={false}
                    tag="success"
                    type="solid"
                    label="تایید"
                    rightIcon=""
                    leftIcon=""
                    onclick={props.confirmSuccess}
                ></Button>
            </Modal>
        </div>
    )
}

export default Success;
